module.exports = __webpack_public_path__ + "static/media/listing-page-jim-corbett.226fc3c1.jpg";